import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { palette } from '../../theme/colors';
import { SolvTheme } from '../../theme/theme';
import { typography } from '../../theme/typography';
import { css, style } from '../../utils/css';
import FormControl, { FormControlProps } from '../FormControl/FormControl';
import InputBase, { InputBaseProps } from '../InputBase/InputBase';

type SelectProps = Omit<
  FormControlProps &
    InputBaseProps &
    React.SelectHTMLAttributes<HTMLSelectElement>,
  'cursor' | 'endIcon'
>;

const StyledSelect = styled.select<{ $dense?: boolean }>(
  {
    backgroundPosition: `right ${SolvTheme.space[2]} center`,
  },
  css`
    background-color: white;
    background-image: url("data:image/svg+xml, %3Csvg width='10' height='7' viewBox='0 0 10 7' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M9.24264 1.24264L5 5.48528L0.757359 1.24264' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    color-adjust: exact;
    border: none;
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    cursor: inherit;
    line-height: inherit;
    color: ${palette.gray[600]};

    border: none;
    display: block;
    width: 100%;
    appearance: none;

    &:focus {
      outline: none;
    }

    &:disabled {
      background: none;
    }
  `,
  style(typography.body),
  ({ $dense }) => style({ px: 2, py: $dense ? 1.5 : 2, borderRadius: 'base' }),
);

const Select = forwardRef(
  (
    {
      title,
      children,
      disabled,
      error,
      helperText,
      optional,
      dense,
      startIcon,
      ...props
    }: SelectProps,
    ref,
  ) => {
    return (
      <FormControl {...{ title, disabled, error, helperText, optional }}>
        <InputBase
          noPadding
          cursor="pointer"
          {...{ dense, startIcon, disabled, error }}
        >
          <StyledSelect
            {...props}
            $dense={dense}
            disabled={disabled}
            ref={ref as any}
          >
            {children}
          </StyledSelect>
        </InputBase>
      </FormControl>
    );
  },
);

Select.displayName = 'Select';
export default Select;
